const sever = process.env.ENV_CONFIG;
const iframe_src_uat = 'https://biuat.ibaiqiu.com';
const iframe_src_prod = 'https://futail.ibaiqiu.com';

const base_wyz = 'http://queen.wyz.local';
const base_cgs = 'http://queen.cgs.local';


function fn_baseUrl() {
    switch(sever){
        case 'dev':
            return {
                // base: 'http://queen.star.local',
                base: base_wyz, // 王永志
                // base: 'http://queen.wfy.local', // 吴方圆
                // base: base_cgs, // 程光顺
                // base: 'http://queen.txr.local', // 唐晓蓉
                // base: 'http://queen.zjtest.local',
                iframe_src: 'https://bi.ibaiqiu.com'
            }
        case 'uat':
            return {
                base: 'https://queenuat-admin.mybaiqiu.com',
                iframe_src: iframe_src_uat
            }
        case 'uat-wyz': // 王永志
            return {
                base: base_wyz,
                iframe_src: iframe_src_uat
            }
        case 'uat-cgs': // 程光顺
            return {
                base: base_cgs,
                iframe_src: iframe_src_uat
            }
        case 'sit':
            return {
                base: 'https://queensit-admin.mybaiqiu.com',
                iframe_src: iframe_src_uat
            }
        case 'prod':
            return {
                base: 'https://queen-admin.ibaiqiu.com',
                iframe_src: iframe_src_prod
            }
        case 'prod-wyz': // 王永志
            return {
                base: base_wyz,
                iframe_src: iframe_src_prod
            }
        case 'prod-cgs': // 程光顺
            return {
                base: base_cgs,
                iframe_src: iframe_src_prod
            }
    }

}

var baseUrl = fn_baseUrl();
module.exports = {
    sever,
    base: baseUrl.base,
    iframe_src: baseUrl.iframe_src
}



// WEBPACK FOOTER //
// ./src/configs/index.js